import napStyles from './../nap.json'

export default {
  borderBottom: `1px solid ${napStyles.colors.PrimaryGrey}`,
  margin: '0',
  mobileWidth: '100%',
  scrollContainerMarginLeft: {
    small: '-8px',
    medium: '-28px',
    large: '-32px'
  },
  sticky: {
    small: {
      offset: '50px'
    },
    medium: {
      marginTop: '50px'
    },
    large: {
      marginTop: 0
    }
  }
}
